import axios from "axios";
export const httpDomainServiceApim = axios.create({
    baseURL: process.env.REACT_APP_DOMAIN_BASE_URL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF": "1",
    },
});
